<div class="carta-img-arrb text-center">
  <img class="img mb-3" src={{imagen}} alt="">
  <p class="texto">{{descripcion}}</p>
</div>
